import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { createAuth } from '../Helpers';
import config from '../config';

export const reducerName = 'eventState';

export const getFutureEvents = createAsyncThunk(
    'eventState/getFutureEvents',
    async (_, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                url: `${config.server}/api/event`,
                method: 'GET',
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const acceptInvite = createAsyncThunk(
    'eventState/acceptInvite',
    async ({invitationId}, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                url: `${config.server}/api/event/${invitationId}/accept`,
                method: 'POST',
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

export const rejectInvite = createAsyncThunk(
    'eventState/rejectInvite',
    async ({invitationId}, { getState, rejectWithValue }) => {
        try {
            const response = await axios({
                url: `${config.server}/api/event/${invitationId}/reject`,
                method: 'POST',
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    events: [],
    showInviteesForEvent: false,
    showInviteeMenu: false,
    status: 'idle',
    error: null,
};

const eventSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        showInviteesForEvent: (state, action) => {
            state.showInviteesForEvent = action.payload.show ? action.payload.eventId : false;
        },
        showInviteeMenu: (state, action) => {
            state.showInviteeMenu = action.payload.show ? action.payload.personId : false;
        },
    },
    extraReducers: (builder) => {
        // getFutureEvents
        builder
            .addCase(getFutureEvents.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getFutureEvents.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (JSON.stringify(state.events) !== JSON.stringify(action.payload)) {
                    state.events = action.payload;
                }
            })
            .addCase(getFutureEvents.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });

        // acceptInvite
        builder
            .addCase(acceptInvite.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(acceptInvite.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.events = action.payload;
            })
            .addCase(acceptInvite.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });

        // rejectInvite
        builder
            .addCase(rejectInvite.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(rejectInvite.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.events = action.payload;
            })
            .addCase(rejectInvite.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export const { showInviteesForEvent, showInviteeMenu } = eventSlice.actions;

export default eventSlice.reducer;